<template lang="pug">
section.twitch
  .content
    .twitch__logos
      img.twitch__logos-item.twitch__logos-item--cb(src="@/assets/images/cb-logo.svg" width="312")
      img.twitch__logos-item.twitch__logos-item--twitch(src="@/assets/images/twitch-logo.svg" width="220")

    .twitch__content
      components(
        :is="getCurrentComponent"
        v-if="showBlock",
        :errorCode="getErrorCode",
        :twitchUser="twitchUser",
        :lsKeys="ls_keys"
        @changeView="changeView"
      )

</template>

<script>
import ls from "@godweb/frontend-base/src/libs/helpers/LocalStorageWrapper";
import UrlParams from "@godweb/frontend-base/src/libs/tools/UrlParams";
import { mapGetters } from "vuex";

import TwitchNotAuth from "./TwitchNotAuth";
import TwitchConnect from "./TwitchConnect";
import TwitchSuccess from "./TwitchSuccess";
import TwitchError from "./TwitchError";

export default {
  name: "Twitch",

  props: {
    showBlock: Boolean,
    twitchDone: Boolean,
    twitchUser: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      page_list: {
        not_auth: TwitchNotAuth,
        connect: TwitchConnect,
        success: TwitchSuccess,
        error: TwitchError,
      },
      ls_keys: {
        logged_in_with: "tw_drops_logged_in_just_now",
        form_to_show: "tw_drops_form_to_show",
      },
      current_component: "not_auth",
    };
  },

  computed: {
    ...mapGetters("global", [
      "isUserProcessed",
      "isUserInProject",
      "isUserNotAuthed",
      "isUserAuthedNotRegistered",
      "isSteamUser",
    ]),

    getErrorCode() {
      return UrlParams.get("errorCode");
    },
    getCurrentComponent() {
      return this.page_list[this.current_component];
    },
  },

  watch: {
    showBlock() {
      this.setCurrentComponent();
    },
  },

  methods: {
    changeView(view) {
      this.current_component = view;
    },
    setCurrentComponent() {
      let form_to_show = ls.getItem(this.ls_keys.form_to_show);
      let logged_in_just_now_with = ls.getItem(this.ls_keys.logged_in_with);

      if (this.getErrorCode) {
        this.current_component = "error";
      } else if (this.twitchDone) {
        this.current_component = "success";
      } else if (this.isUserInProject) {
        if (logged_in_just_now_with) {
          this.current_component = "connect";
          ls.setItem(this.ls_keys.logged_in_with, null);
        }
      } else {
        if (form_to_show && (form_to_show === "steam" || form_to_show === "mygames")) {
          form_to_show === "steam"
            ? this.$authService.showSteamSignin()
            : this.$authService.showSignin();
          ls.setItem(this.ls_keys.form_to_show, null);
          ls.setItem(this.ls_keys.logged_in_with, form_to_show);
        }
      }
      return this.page_list[this.current_page];
    },
  },
};
</script>
